import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import React, { useCallback } from "react";
import { useDropzone } from 'react-dropzone';
import { Controller } from 'react-hook-form';
import { format } from 'react-string-format';
import { constants } from '../constants';
import { MyMVariantButton } from '../ui-elements/MyMButton';
import { MyMLabel } from '../ui-elements/MyMLabel';
import { utility } from '../utility';

// MyMine Version2.0 コンポーネント共通化
/**
 * ValidatableAttachmentFiles Component
 */
const ValidatableAttachmentFiles = ({
  controlSettings,
  messageList,
  control,
  files,
  setFiles,
  clearErrors,
  formState,
  trigger,
  fileSizeValidMessageKey,
  // 2025.3.5 MyMine Version2.1対応 Add Start
  allowFileSizeZero = true,
  allowDuplicateFileName = true,
  // 2025.3.5 MyMine Version2.1対応 Add End
}) => {

  const onDrop = useCallback(acceptedFiles => {
    for (const acceptedFile of acceptedFiles) {
      files.push(acceptedFile);
    }
    (async () => {
      if (!formState.isSubmitted) return;
      await trigger('files');

    })();
  }, [files, formState.isSubmitted])

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
  })

  return (
    <FormControl error={formState.errors['files'] ? true : false} sx={{ width: "100%" }}>
      <Controller
        control={control}
        name={'files'}
        defaultValue={files}
        render={({ field: { onChange } }) => (
          <Box sx={{
            width: '100%',
            height: '165px',
            padding: '10px',
            border: `3px dashed   ${formState.errors['files'] ? '#d32f2f' : 'rgb(190, 190, 190)'}`,
            borderRadius: '5px',
            overflow: 'auto',
            backgroundColor: 'rgba(190, 190, 190, 0.5)'
          }}>
            <div {...getRootProps({ className: "dropzone", style: { cursor: 'pointer', minHeight: '120px', } })}>
              <input {...getInputProps()} />
              <MyMLabel sx={{ lineHeight: '40px' }}>{controlSettings.LabelList.lblAttachmentFile}</MyMLabel>
              <Box sx={{ padding:'20px' }} />
            <aside>
              <ul>
                {files.map((file, i) => {
                  return (
                    <li key={i}>
                      {file.path} - {utility.convertFileSize(file.size, constants.FileSize.MB).toFixed(2)} MB
                    </li>
                  )
                })}
              </ul>
              </aside>
            {files.length > 0 &&
              <MyMVariantButton
                sx={{
                  border: '2px solid #777777',
                  borderRadius: '10px',
                  fontSize: '1rem',
                  color: '#000000',
                  margin: '10px',
                  width: '190px',
                  backgroundColor: ' #fff',
                  ':hover': {
                    backgroundColor: ' #fff',
                  }
                  }} onClick={(e) => { e.stopPropagation(); setFiles([]); clearErrors('files'); }}>{controlSettings.LabelList.lblRemoveAll}</MyMVariantButton>}
            </div>
          </Box>
        )}
        rules={{
          validate: {
          // ファイル件数チェック
            maxFileCount: () => {
              return files.length > 3 ? format(messageList.MyM_MSG_E_0084, 3) : true
            },
            // 最大ファイルサイズチェック
            maxFileSize: () => {
              let isError = false;
              for (const file of files) {
                if (file.size > 2097152) {
                  isError = true;
                }
              }
              return isError ? format(messageList[fileSizeValidMessageKey], Math.floor(utility.convertFileSize(2097152, constants.FileSize.MB))) : true;
            },
            // 2025.3.5 MyMine Version2.1対応 Add Start
            // 最小ファイルサイズチェック
            minFileSize: () => {
              // サイズ:0を許容する場合、チェックしない
              if (allowFileSizeZero) { return true; }
              let isError = false;
              for (const file of files) {
                if (file.size === 0) {
                  isError = true;
                }
              }
              return isError ? messageList.MyM_MSG_W_0152 : true;
            },
            // ファイル名重複チェック
            duplicateFileName: () => {
              // 重複を許容する場合、チェックしない
              if (allowDuplicateFileName) { return true; }
              const uniqueFileNames = new Set(files.map(file => file.name));
              return uniqueFileNames.size !== files.length ? messageList.MyM_MSG_E_0155 : true;
            },
            // 2025.3.5 MyMine Version2.1対応 Add End
          }
        }}
      />
      <FormHelperText >{formState.errors['files']?.message}</FormHelperText>
      <FormHelperText >{formState.errors['files']?.message2}</FormHelperText>
    </FormControl>
  );
}
export default ValidatableAttachmentFiles;